export const config = {
  rowSelection: false,
  columns: [
    { title: '子项ID', dataIndex: 'id', width: 200 },
    { title: '子项名称', dataIndex: 'itemName', width: 300, ellipsis: true },
    { title: '备注', dataIndex: 'remarks', width: 350, ellipsis: true },
    { title: '特项代码', dataIndex: 'specialCode', width: 200, ellipsis: true },
    { title: '创建人', dataIndex: 'createdByName', width: 200 },
    { title: '创建时间', dataIndex: 'createdTime', itemType: 'dateTime', width: 200 },
    { title: '状态', dataIndex: 'enabled', width: 90, render: 'switchRender', fixed: 'right' },
    { title: '操作', dataIndex: '#', width: 125, render: 'actionRender', fixed: 'right' },
  ],
  search: [
    { label: '子项名称', name: 'itemNameKeyword' },
    { label: '子项ID', name: 'id' },
    {
      label: '子项状态',
      name: 'enabled',
      itemType: 'select',
      labelKey: 'label',
      key: 'value',
      data: [
        { label: '启用', value: true },
        { label: '禁用', value: false },
      ],
    },
  ],
  footer: [{ label: '新增', type: 'primary', events: ['onClick:onAdd'] }],
}
